import {
	SHOP_MODIFIER_UPDATE_START,
	SHOP_MODIFIER_UPDATE_SUCCESS,
	SHOP_MODIFIER_UPDATE_ERROR
} from '../../../constants/index';
import { toastr } from 'react-redux-toastr';
import getAllModifierQuery from '../../../routes/shop/modifierGroups/getAllModifier.graphql';
import deleteModifierMutation from './deleteModifier.graphql';
import { getAllShopModifier } from './getAllShopModifier';

export default function deleteModifier(id, currentPage, searchList) {
	return async (dispatch, getState, { client }) => {
		dispatch({
			type: SHOP_MODIFIER_UPDATE_START,
			payload: {
				updateLoading: true
			}
		});

		try {
			let errorMessage;
			const { data: { deleteModifier } } = await client.mutate({
				mutation: deleteModifierMutation,
				variables: {
					id
				},
				refetchQueries: [{ query: getAllModifierQuery, variables: { currentPage, searchList } }]
			});

			if (deleteModifier && deleteModifier.status === 200) {
				dispatch({
					type: SHOP_MODIFIER_UPDATE_SUCCESS,
					payload: {
						updateLoading: false
					}
				});
				toastr.success('Success!', `The Modifier has been deleted successfully.`);
			} else {
				dispatch({
					type: SHOP_MODIFIER_UPDATE_ERROR,
					payload: {
						updateLoading: false
					}
				});

				errorMessage = (deleteModifier && deleteModifier.errorMessage) || "Oops! Something went wrong. Please try again.";
				toastr.error('Error!', errorMessage);
			}
			dispatch(getAllShopModifier());

		} catch (err) {
			toastr.error('Error!', err);
			dispatch({
				type: SHOP_MODIFIER_UPDATE_ERROR,
				payload: {
					updateLoading: false
				}
			});
		}
	}
};
